import React, {FC} from 'react';

import {TimelineCommentators} from 'utils/types';

import './styles.scss';

interface Props {
  commentary?: TimelineCommentators;
  commentaryEnabled: boolean;
  setCommentaryEnabled: React.Dispatch<React.SetStateAction<boolean>>;
}

const TimelineCommentary: FC<Props> = ({
  commentary,
  commentaryEnabled,
  setCommentaryEnabled,
}: Props) => {
  return commentary && (!!commentary.reporters.length || !!commentary.commentators.length) ? (
    <div className="TimelineCommentary">
      {!!commentary.reporters.length && (
        <div>
          <h5 className="TimelineCommentary__label">ΠΕΡΙΓΡΑΦΗ</h5>
          <p className="TimelineCommentary__commentators">{commentary.reporters.join(', ')}</p>
        </div>
      )}
      {!!commentary.commentators.length && (
        <div>
          <h5 className="TimelineCommentary__label">ΣΧΟΛΙΑΣΜΟΣ</h5>
          <p className="TimelineCommentary__commentators">{commentary.commentators.join(', ')}</p>
        </div>
      )}
    </div>
  ) : null;
};

export default TimelineCommentary;
